import { handleResponse, hx_handleResponse } from './process';
// 请求层唯一入口：服务（主接口/op 接口/电影/旅游）+ 出口工具都在这一处
import {
  service,
  movieService,
  tourService,
  httpRequest,
  ENVELOPE,
  isAmapUrl
} from '@/lib/request';

// 说明：第三个参数 options 是本次请求的额外选项（如 { validate: false } 关闭
// 「无效值不发送」校验、{ skipAutoDialog: true } 关闭「响应带 dialog 就自动弹窗」、
// { hideMessage: true } 关闭「非 0 码自动提示后端 message」——页面要自己提示时用），
// 不传时按全局默认（校验 + 自动弹）。
// 同一套写法按服务批量生成，避免每加一个域名就抄一遍（域名登记见 src/config/api.js）：
//   request      → main  ：主接口
//   movieRequest → movie ：电影读接口（影片源只配在正式网关）
//   tourRequest  → tour  ：携程景点「目录/资源」读接口（景点数据只在正式网关齐全）
const makeRequest = svc => (url, data, options = {}) =>
  new Promise((resolve, reject) => {
    svc
      .post(url, data, options)
      .then(res => {
        // options 一并交给响应处理：如 { skipAutoDialog: true } 表示本次请求
        // 响应里的 dialog 不在请求层自动弹（把弹窗时机交还页面）
        const handledData = handleResponse(res, options);
        handledData.then(resp => resolve(resp)).catch(err => reject(err));
      })
      .catch(err => reject(err));
  });

export const request = makeRequest(service);
export const movieRequest = makeRequest(movieService);
export const tourRequest = makeRequest(tourService);

// 核销post请求——变更code处理
export function hx_request(url, data, options = {}) {
  return new Promise((resolve, reject) => {
    service
      .post(url, data, options)
      .then(res => {
        const handledData = hx_handleResponse(res);
        handledData.then(resp => resolve(resp)).catch(err => reject(err));
      })
      .catch(err => reject(err));
  });
}
export function requestWithGet(url, data = {}, options = {}) {
  return new Promise((resolve, reject) => {
    service
      .get(url, data, options)
      .then(res => {
        // 高德地图请求数据因数据格式不同需单独处理（同源 /amap 代理 或 绝对地址）
        // 统一走 isAmapUrl（同一份判定，避免两处正则各自演化）
        if (isAmapUrl(url)) {
          if (+res.infocode === 10000) {
            resolve(res);
          } else {
            reject(res);
          }
        } else {
          const handledData = handleResponse(res);
          handledData.then(resp => resolve(resp)).catch(err => reject(err));
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function requestWithDelete(url, data, options = {}) {
  return new Promise((resolve, reject) => {
    service
      .delete(url, data, options)
      .then(res => {
        const handledData = handleResponse(res);
        handledData.then(resp => resolve(resp)).catch(err => reject(err));
      })
      .catch(err => reject(err));
  });
}

export function requestWithPut(url, data, options = {}) {
  return new Promise((resolve, reject) => {
    service
      .put(url, data, options)
      .then(res => {
        const handledData = handleResponse(res);
        handledData.then(resp => resolve(resp)).catch(err => reject(err));
      })
      .catch(err => reject(err));
  });
}

/**
 * 平铺 GET（通用）：参数直接进 query，不做主接口的 { header, body } 信封包装
 * 对齐 mall_h5 createHttpService 的 get：默认注入 token / platform:2 / city_id / channel_id / custom_id。
 * 适用于「按 query 平铺取参」的接口（getBanner 已在用，其他同类接口可直接复用）。
 * 可选项（写在 params 里，不会发给后端）：
 *   - hideAddCommonParam: true  不注入 platform / city_id / channel_id / custom_id
 *   - hideToken: true           不注入 token
 * 注意：未登录不跳登录页（首页/商城这类公开页面也会调）
 * @param {string} url 请求地址
 * @param {object} params 查询参数
 * @returns {Promise}
 */
export function requestFlatGet(url, params = {}) {
  return new Promise((resolve, reject) => {
    // 平铺 GET：参数直接进 query（不做 { header, body } 信封包装），未登录不跳登录页。
    // token / platform / city_id / channel_id / custom_id 的注入统一在请求出口里做
    // （hideToken、hideAddCommonParam 为本地开关，不会发给后端）
    httpRequest({
      service: 'main',
      method: 'get',
      url,
      params,
      envelope: ENVELOPE.FLAT,
      login: false
    })
      .then(res => {
        const body = res && res.data;
        // 平铺结构：{ code, message, data } —— 不能用 handleResponse
        // （它读的是 response.header.code，平铺响应取不到 code，会把成功响应 reject 掉）
        if (!body || !body.header) {
          if (body && +body.code === 0) {
            resolve(body.data);
          } else {
            reject(body || res);
          }
          return;
        }
        // 信封结构：{ header: { code }, body } 时仍走统一处理（传信封，不能传 axios 响应对象）
        const handledData = handleResponse(body);
        handledData.then(resp => resolve(resp)).catch(err => reject(err));
      })
      .catch(err => reject(err));
  });
}
